"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preloader = void 0;
class Preloader {
    static initPreloader() {
        if (!this.getCookie('hidePreloader')) {
            const preloader = document.getElementById('preloader');
            if (preloader !== null) {
                this.createCookie('hidePreloader', true, 1);
                setTimeout(function () {
                    preloader.style.display = 'none';
                }, 1800);
            }
        }
    }
    static createCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = date.toUTCString();
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }
    static getCookie(cookie) {
        const nameEQ = cookie + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }
}
exports.Preloader = Preloader;
